import { Link } from "react-router-dom";
import { MapPin, Phone, User } from "lucide-react";
import { COMPANY, NAV_LINKS, SERVICES } from "../data/site";

const Footer = () => (
  <footer className="border-t border-line bg-white" data-testid="site-footer">
    <div className="mx-auto grid max-w-7xl gap-12 px-6 py-16 sm:grid-cols-2 lg:grid-cols-4 lg:px-10">
      <div>
        <Link to="/" data-testid="footer-logo">
          <img src="/epg-logo-dark.png" alt="Executive Print Group" className="h-14 w-auto" data-testid="footer-logo-img" />
        </Link>
        <p className="mt-6 max-w-xs text-sm leading-relaxed text-slate">
          Premium commercial printing backed by advanced technology, rigorous quality control and dependable execution.
        </p>
      </div>
      <div>
        <h3 className="label-caps">Navigate</h3>
        <ul className="mt-5 space-y-3">
          {NAV_LINKS.map((l) => (
            <li key={l.to}>
              <Link
                to={l.to}
                data-testid={`footer-link-${l.label.toLowerCase()}`}
                className="text-sm text-slate transition-colors hover:text-brand"
              >
                {l.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>
      <div>
        <h3 className="label-caps">Services</h3>
        <ul className="mt-5 space-y-3">
          {SERVICES.map((s) => (
            <li key={s.num} className="text-sm text-slate">
              {s.name}
            </li>
          ))}
        </ul>
      </div>
      <div>
        <h3 className="label-caps">Contact</h3>
        <ul className="mt-5 space-y-4 text-sm text-slate">
          <li className="flex gap-3">
            <MapPin size={16} className="mt-0.5 shrink-0 text-brand2" />
            <span>{COMPANY.addressLines.join(" ")}</span>
          </li>
          <li className="flex gap-3">
            <Phone size={16} className="mt-0.5 shrink-0 text-brand2" />
            <a href={`tel:${COMPANY.phone.replace(/\s/g, "")}`} data-testid="footer-phone" className="transition-colors hover:text-brand">
              {COMPANY.phone}
            </a>
          </li>
          <li className="flex gap-3">
            <User size={16} className="mt-0.5 shrink-0 text-brand2" />
            <span>{COMPANY.ceo}, CEO</span>
          </li>
        </ul>
      </div>
    </div>
    <div className="border-t border-line bg-canvas">
      <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-3 px-6 py-6 sm:flex-row sm:items-center lg:px-10">
        <p className="text-xs text-slate">© {new Date().getFullYear()} Executive Print Group, Bangalore</p>
        <p className="text-xs font-medium text-navy">Precision in Every Print.</p>
      </div>
    </div>
  </footer>
);

export default Footer;
